export enum FieldNames {
    id = 'id',
    configuration = 'configuration',
    currency = 'currency',
    ticketNumberLength = 'ticketNumberLength',
    paymasterPrefix = 'paymasterPrefix',
    detailedBillingConfiguration = 'detailedBillingConfiguration',
    microsOutlets = 'microsOutlets',
    protocol = 'protocol',

    /** DetailedBillingConfiguration */
    detailedBillingConfigurationUseDetailedBilling = 'detailedBillingConfiguration.useDetailedBilling',
    detailedBillingConfigurationGenerateReversalTransaction = 'detailedBillingConfiguration.generateReversalTransaction',
    detailedBillingConfigurationReversalPaymasterId = 'detailedBillingConfiguration.reversalPaymasterId',
    detailedBillingConfigurationUseMultiDepartment = 'detailedBillingConfiguration.useMultiDepartment',

    useDetailedBilling = 'useDetailedBilling',
    generateReversalTransaction = 'generateReversalTransaction',
    reversalPaymasterId = 'reversalPaymasterId',
    useMultiDepartment = 'useMultiDepartment',

    /** Micros Outlet */
    outletBillId = 'outletBillId',
    menuNumber = 'menuNumber',
    name = 'name',
    serviceId = 'serviceId',
    tipsAccountingCategory = 'tipsAccountingCategory',
    serviceChargeAccountingCategory = 'serviceChargeAccountingCategory',
    discountAccountingCategory = 'discountAccountingCategory',
    taxCodes = 'taxCodes',

    tipsAccountingCategoryId = 'tipsAccountingCategory.id',
    tipsAccountingCategoryTaxCodes = 'tipsAccountingCategory.taxCodes',

    serviceChargeAccountingCategoryId = 'serviceChargeAccountingCategory.id',
    serviceChargeAccountingCategoryTaxCodes = 'serviceChargeAccountingCategory.taxCodes',

    discountAccountingCategoryId = 'discountAccountingCategory.id',
    discountAccountingCategoryTaxCodes = 'discountAccountingCategory.taxCodes',

    paymentMappings = 'paymentMappings',

    netSalesAccountingCategories = 'netSalesAccountingCategories',
    categoryId = 'categoryId',

    /** PaymentMappings */
    paymentNumber = 'paymentNumber',
    paymasterId = 'paymasterId',
    accountingCategoryId = 'accountingCategoryId',
    externalPaymentType = 'externalPaymentType',
    isDefault = 'isDefault',
}
